export default "__VITE_ASSET__Xxl1iBxr__"